import React from 'react';
import { BrowserRouter, Routes, Route, NavLink, Outlet } from 'react-router-dom';
import { LayoutDashboard, Calendar, SmilePlus, MessageSquare, Settings, Users, Clock, ShieldCheck } from 'lucide-react';
import { DailyOverviewPage } from './pages/DailyOverviewPage';
import { UnifiedCalendarPage } from './pages/UnifiedCalendarPage';
import { AvailabilityManagerPage } from './pages/AvailabilityManagerPage';
import { NpsPage } from './pages/NpsPage';
import { WhatsAppLogPage } from './pages/WhatsAppLogPage';
import { StaffPage } from './pages/StaffPage';
import { SettingsPage } from './pages/SettingsPage';
import { CompliancePage } from './pages/CompliancePage';
import { I18nProvider, useI18n, LanguageToggle } from './i18n';

function Sidebar() {
    const { t } = useI18n();
    const links = [
        { to: '/', icon: LayoutDashboard, label: t('nav.dailyOverview') },
        { to: '/calendar', icon: Calendar, label: 'Calendario' },
        { to: '/availability', icon: Clock, label: 'Disponibilidad' },
        { to: '/nps', icon: SmilePlus, label: 'NPS Analytics' },
        { to: '/whatsapp', icon: MessageSquare, label: 'WhatsApp Log' },
        { to: '/staff', icon: Users, label: t('nav.staff') },
        { to: '/compliance', icon: ShieldCheck, label: 'Compliance' },
        { to: '/settings', icon: Settings, label: t('nav.settings') },
    ];

    return (
        <aside className="sidebar">
            <h2>Vriksha.Health</h2>
            <p>{t('coordinator.subtitle')}</p>
            {links.map(l => (
                <NavLink key={l.to} to={l.to} end={l.to === '/'}
                    className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}>
                    <l.icon size={18} /> {l.label}
                </NavLink>
            ))}
            <div style={{ marginTop: 'auto', padding: '1rem 0' }}>
                <LanguageToggle />
            </div>
        </aside>
    );
}

function Layout() {
    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main"><Outlet /></main>
        </div>
    );
}

export function App() {
    return (
        <I18nProvider>
            <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, '')}>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<DailyOverviewPage />} />
                        <Route path="/calendar" element={<UnifiedCalendarPage />} />
                        <Route path="/availability" element={<AvailabilityManagerPage />} />
                        <Route path="/nps" element={<NpsPage />} />
                        <Route path="/whatsapp" element={<WhatsAppLogPage />} />
                        <Route path="/staff" element={<StaffPage />} />
                        <Route path="/compliance" element={<CompliancePage />} />
                        <Route path="/settings" element={<SettingsPage />} />
                        <Route path="*" element={
                            <div className="fade-in" style={{ textAlign: 'center', padding: 48, color: 'var(--text-3)' }}>
                                <h1>404</h1><p>Página no encontrada</p>
                            </div>
                        } />
                    </Route>
                </Routes>
            </BrowserRouter>
        </I18nProvider>
    );
}

